import { useRef } from 'react'
import { Alert, AlertIcon, Button, Icon, Text } from '@chakra-ui/react'
import { faTrashCan } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { CustomConfirmDialog } from '@/components/CustomConfirmDialog'

export const DeletePendingDialog = ({ isOpen, onClose, onConfirm, isDeleting, deleteError }: {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isDeleting: boolean
  deleteError?: string
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null)

  return (
    <CustomConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      leastDestructiveRef={cancelRef}
      title="Odstranit verzi s mimořádnou slevou?"
      yesButton={{
        customElement: (
          <Button
            colorScheme="red"
            ml={3}
            onClick={onConfirm}
            isLoading={isDeleting}
            leftIcon={<Icon as={FontAwesomeIcon} icon={faTrashCan} />}
          >
            Odstranit
          </Button>
        ),
      }}
      noButton={{
        customElement: (
          <Button variant="outline" colorScheme="gray" ref={cancelRef} onClick={onClose} isDisabled={isDeleting}>
            Ponechat
          </Button>
        ),
      }}
    >
      <Text fontSize="sm" color="gray.600">
        Čekající verze bude odstraněna a nebude aplikována. Tuto akci nelze vzít zpět.
      </Text>
      {deleteError && (
        <Alert status="error" fontSize="sm" mt={3}>
          <AlertIcon />
          {deleteError}
        </Alert>
      )}
    </CustomConfirmDialog>
  )
}
